import React from 'react'
import { Box, Typography, Grid } from '@mui/material'

/**
 * Botones con código de color para selección única.
 * options: [{ value: 'low', label: 'Bajo', color: '#4caf50' }]
 */
const ColorButtonGroup = ({ label, options = [], selected, onChange, columns = 4, icon: Icon }) => {
  return (
    <Box>
      {label && (
        <Typography variant="body2" fontWeight={500} mb={1.5} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {Icon && <Icon sx={{ fontSize: 18, color: 'primary.main' }} />}
          {label}
        </Typography>
      )}
      <Grid container spacing={1}>
        {options.map((option) => {
          const isSelected = selected === option.value

          return (
            <Grid item xs={6} sm={12 / columns} key={option.value}>
              <Box
                onClick={() => onChange(option.value)}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: 1.5,
                  borderRadius: 2,
                  border: '2px solid',
                  borderColor: isSelected ? option.color : 'divider',
                  bgcolor: isSelected ? `${option.color}15` : 'background.paper',
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  '&:hover': { borderColor: option.color },
                }}
              >
                <Box
                  sx={{
                    width: 14,
                    height: 14,
                    borderRadius: '50%',
                    bgcolor: option.color,
                    mb: 0.5,
                  }}
                />
                <Typography variant="caption" fontWeight={isSelected ? 700 : 500}>
                  {option.label}
                </Typography>
              </Box>
            </Grid>
          )
        })}
      </Grid>
    </Box>
  )
}

export default ColorButtonGroup
